import { Region } from "@/gql/graphql";
import { useTranslations } from "use-intl";
import { MultiSelectFilter } from "@/lib/Components/DataTable/Filters/MultiSelectFilter";

export function RegionFilter({
  selected,
  onChange,
}: {
  selected: Region[];
  onChange: (newRegions: Region[]) => void;
}) {
  const t = useTranslations("city");
  const options = Object.values(Region).map((r) => ({
    label: t(`region.${r}`),
    value: r,
  }));

  return (
    <MultiSelectFilter
      label={t("regionLabel")}
      options={options}
      selected={selected}
      onChange={onChange}
    />
  );
}
